export default __webpack_public_path__ + "static/media/Arrow_Up.226d7350.svg";